import React from 'react'
import styled, { css } from 'styled-components'

const Bar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  ${(p) => p.$variant === 'card' && css`
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.radii.lg};
    background: ${({ theme }) => theme.colors.surface};
    box-shadow: ${({ theme }) => theme.shadow.sm};
    padding: 10px 12px;
  `}
`

const TabBtn = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.muted};
  padding: 10px 12px;
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: 600;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii.md};
  position: relative;
  &:hover { color: ${({ theme }) => theme.colors.text}; }
  ${(p) => p.$active && css`
    color: ${p.theme.colors.primary};
    &:after {
      content: '';
      position: absolute;
      left: 12px; right: 12px; bottom: -1px;
      height: 2px; background: ${p.theme.colors.primary};
      border-radius: 2px;
    }
  `}
`

export function Tabs({ items = [], value, onChange, variant = 'card', rightContent }) {
  return (
    <Bar $variant={variant}>
      <div style={{ display: 'flex', gap: '8px', flex: 1 }}>
        {items.map((it) => (
          <TabBtn key={it.key} onClick={() => onChange && onChange(it.key)} $active={it.key === value}>
            {it.label}
          </TabBtn>
        ))}
      </div>
      {rightContent && <div style={{ marginLeft: 'auto', flexShrink: 0 }}>{rightContent}</div>}
    </Bar>
  )
}

